import React from 'react';
import { Box, Button, MenuItem, TextField, Typography, ButtonGroup } from '@mui/material';

const AdvancedFilters = ({ filters, setFilters, filterOptions }) => {
  return (
    <Box sx={{ mb: 3, p: 2, border: '1px solid #eee', borderRadius: 1 }}>
      <Typography variant="subtitle1" gutterBottom>
        Filter Members
      </Typography>

      <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', alignItems: 'center' }}>
        {/* Payment Status Filter */}
        <TextField
          select
          label="Payment Status"
          value={filters.paymentStatus}
          onChange={(e) => setFilters({...filters, paymentStatus: e.target.value})}
          sx={{ minWidth: 150 }}
        >
          <MenuItem value="all">All</MenuItem>
          <MenuItem value="paid">Paid</MenuItem>
          <MenuItem value="unpaid">Unpaid</MenuItem>
          <MenuItem value="future">Future</MenuItem>
        </TextField>

        {/* Country Filter */}
        <TextField
          select
          label="Country"
          value={filters.country}
          onChange={(e) => setFilters({...filters, country: e.target.value})}
          sx={{ minWidth: 150 }}
        >
          <MenuItem value="">All Countries</MenuItem>
          {filterOptions.countries?.map((country) => (
            <MenuItem key={country} value={country}>
              {country}
            </MenuItem>
          ))}
        </TextField>

        {/* Quick Filter Buttons */}
        <ButtonGroup variant="outlined" sx={{ ml: 1 }}>
          <Button onClick={() => setFilters({
            ...filters,
            paymentStatus: 'paid',
            country: ''
          })}>
            Paid Only
          </Button>
          <Button onClick={() => setFilters({
            ...filters,
            paymentStatus: 'unpaid',
            country: ''
          })}>
            Unpaid Only
          </Button>
        </ButtonGroup>

        {/* Reset Button */}
        <Button
          variant="outlined"
          onClick={() => setFilters({
            paymentStatus: 'all',
            country: ''
          })}
          sx={{ ml: 'auto' }}
        >
          Reset All
        </Button>
      </Box>
    </Box>
  );
};

export default AdvancedFilters;